import { FC } from 'react';

const MenuItemBadge: FC<{ count: number }> = ({ count }) => {
  return (
    <div
      className="absolute top-[-5px] right-0 min-w-[18px] bg-red-500 rounded-full text-white text-center leading-4 px-1 py-[1px] text-[10px] font-medium"
      data-test-id="menu-item-badge"
    >
      {count}
    </div>
  );
};

export default MenuItemBadge;
